import { NEW_ORDER } from '../actionTypes';

export const fetchIsNewOrder = (isNewOrder) => ({
  type: NEW_ORDER,
  payload: isNewOrder,
});
